import React from 'react' 
import { useTranslation } from 'react-i18next'
import { NavLink } from 'react-router-dom'

const Sizes = ({slug, lang}) => {
    const [_] = useTranslation('global');
  return (
    <li>
       
    <NavLink to={`/${slug}/${lang}/panel/products/sizes`}>
      <p className="d-inline ">{_("panel.sizes")}</p>
    </NavLink>
  </li>
  )
}

export default Sizes
